export default __webpack_public_path__ + "static/media/qrcode-app.24a40def.svg";